import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'loading-overlay',
    template: require('./loading-overlay.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingOverlayComponent {
    @Input() loading: boolean;
}


// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/loading-overlay/loading-overlay.component.ts